import ChargerInfo from "./ChargerInfo";
import { chargerDetailsMap } from "./constants";
import PropTypes from "prop-types";
import { LoaderCircle } from "lucide-react";

import useChargerConfig from "./hooks/useChargerConfig";
import { useGlobalFilters } from "../../lib/context/GlobalFilterProvider";
import ErrorCard from "../../lib/components/ErrorCard";
import { formatDate } from "../../lib/utils/utility";

function ChargerDetails() {
  const { siteId, serialNumber } = useGlobalFilters();
  const { config, loading, error } = useChargerConfig(siteId, serialNumber);

  const dateKeys = new Set(["lastReportedAt", "createdAt", "warrantyDueDate", "warrantyStartDate"]);

  function formatValue(key, value) {
    if (dateKeys.has(key)) return formatDate(value);
    return value ? String(value) : "-";
  }
  function renderDetails(data) {
    if (!data) return <div className="text-gray-500 p-4">No data available</div>;
    return (
      <div>
        {Object.keys(chargerDetailsMap).map((key, idx, arr) => (
          <div key={key}>
            <ChargerInfo label={chargerDetailsMap[key]} value={formatValue(key, data[key])} />
            {idx < arr.length - 1 && <div className="border-t border-gray-200 mx-2" />}
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="charger-info">
      <div className="px-6 pt-5 pb-2 charger-details-header">
        <span className="charger-details-title">Charger Status and Configuration</span>
      </div>
      <div className="px-6 py-3 flex-1 flex items-center justify-center">
        {loading && (
          <div className="flex flex-col items-center justify-center w-full h-full">
            <LoaderCircle className="animate-spin charger-details-loader mb-2" size={38} />
            <span className="charger-details-loader-text text-base font-medium">Loading...</span>
          </div>
        )}
        {error && <ErrorCard errorText={"Error loading config"} />}
        {!loading && !error && <div className="w-full">{renderDetails(config)}</div>}
      </div>
    </div>
  );
}
ChargerDetails.propTypes = {
  serialNumber: PropTypes.string.isRequired,
  siteId: PropTypes.string.isRequired,
};

export default ChargerDetails;
